module.exports = __webpack_public_path__ + "static/media/fb.59ce02e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fb.png
// module id = 203
// module chunks = 0